<template>
  <base-container ref="container">
    <ArtisanGrid
      :query="{ reserveWardName: wardName }"
      ref="notice"
      metaKey="BedAuditNotice"
      :cellClassName="cellClassName"
      :opColumnWidth="70"
    >
      <template #patientName="{ row }">
        <span>{{ row.patientName }}</span>
        <el-button
          style="text-decoration: underline"
          type="text"
          class="color-primary"
          size="mini"
          @click="bedBack(row)"
        >
          (反馈)
        </el-button>
      </template>
    </ArtisanGrid>
    <artisan-dialog
      :title="title"
      :visible.sync="show"
      width="500px"
      height="270px"
      ref="dialog"
    >
      <el-form
        ref="form"
        size="mini"
        :model="formData"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="反馈">
          <el-radio-group v-model="formData.status">
            <el-radio label="yes">确认入院</el-radio>
            <el-radio label="no">无入院计划</el-radio>
            <el-radio label="other">改期入院</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="反馈说明">
          <el-input
            type="textarea"
            v-model="formData.remark"
            maxlength="100"
            show-word-limit
            rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button
          type="primary"
          icon="el-icon-check"
          size="mini"
          @click="confirm"
          >确认</el-button
        >
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { confirm } from "@/api/bed/reserve";
import moment from "moment";
export default {
  props: {
    wardId: String,
    wardName: String,
  },
  data() {
    return {
      show: false,
      formData: {
        recordId: "",
        status: "",
        remark: "",
      },
      row: {},
      rules: {
        status: [
          { required: true, message: "请输入活动名称", trigger: "change" },
        ],
        remark: [
          {
            min: 0,
            max: 100,
            message: "长度在 3 到 5 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    title() {
      return this.row.patientName + "--反馈";
    },
  },
  methods: {
    cellClassName({ row }) {
      let diff = moment().diff(moment(row.createTime), "minutes", true);
      if (diff >= 120) {
        return "color-danger";
      }
      return "";
    },
    bedBack(row) {
      this.row = row;
      this.formData.recordId = row.id;
      this.formData.status = "yes";
      this.formData.remark = "";
      this.show = true;
    },
    confirm() {
      this.$refs.container.confirm({ msg: "确认反馈？" }).then(() => {
        confirm(this.formData).then(() => {
          this.show = false;
          this.$message({
            type: "success",
            message: "反馈成功！",
          });
          this.$refs.notice.reload();
          this.$emit("bedBacked");
        });
      });
    },
  },
};
</script>

<style scoped></style>
